<mat-accordion *ngIf="trainingGroupSkeletons && trainingGroupSkeletons.length > 0; else noGroups">
  <mat-expansion-panel
    *ngFor="let trainingGroupSkeleton of trainingGroupSkeletons"
    (opened)="onOpened(trainingGroupSkeleton.trainingGroupId)"
  >
    <mat-expansion-panel-header>{{
      trainingGroupSkeleton.trainingGroupName
    }}</mat-expansion-panel-header>

    <ng-template matExpansionPanelContent>
      <div *ngIf="loading; else auditsLoaded">Loading...</div>
      <ng-template #auditsLoaded>
        <div *ngIf="audits && audits.length > 0; else noAudits">
          <sd-portal-audit-detail-list
            (nextPage)="onNextPage(trainingGroupSkeleton.trainingGroupId)"
            [audits]="audits"
          ></sd-portal-audit-detail-list>
        </div>
        <ng-template #noAudits> No audit records for this training group </ng-template>
      </ng-template>
      <sd-portal-training-group-training-requirement-audit-list
        [trainingGroupTrainingRequirementSkeletons]="
          trainingGroupSkeleton.trainingGroupTrainingRequirements
        "
        [trainingGroupTrainingRequirementAuditLoading]="
          trainingGroupTrainingRequirementAuditLoading
        "
        [trainingGroupTrainingRequirementAudits]="trainingGroupTrainingRequirementAudits"
        (opened)="onOpenedTrainingGroupTrainingRequirement($event)"
        (nextPage)="onNextTrainingGroupTrainingRequirementPage($event)"
      >
      </sd-portal-training-group-training-requirement-audit-list>
    </ng-template>
  </mat-expansion-panel>
</mat-accordion>
<ng-template #noGroups> No training groups to audit </ng-template>
